import MovimentoEstoque from "model/suprimentos/MovimentoEstoque";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    movimentoEstoque: MovimentoEstoque | null;
}

export default function ObservacaoMovimentoModal(props: Props) {

    return (
        <>
            <Dialog header="Observações" visible={props.visible} baseZIndex={500} style={{ width: '40vw' }} onHide={() => props.setVisible(false)}>
                <div className="row">
                    <label className="col col-sm-12">Observação</label>
                    <div className="col-sm-12" style={{ width: '90%' }}>
                        <textarea
                            required value={props.movimentoEstoque?.observacao || ''}
                            style={{ width: '100%' }}
                            rows={4}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    )
}